import React, { useEffect, useState } from 'react';
import { TickerDetail } from './TickerDetail';
import { host } from './env';
import CanvasItem from './avwapp.chart';
import ProfileRow from './ProfileRow';

type StockPopupProps = {
  symbol: string;
};

const StockPopupButton: React.FC<StockPopupProps> = ({ symbol }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [detail, setDetail] = useState<TickerDetail | null>(null);

  const handleClick = async () => {
    try {
      const response = await fetch(
        `${host}/getTicker?ticker=${encodeURIComponent(symbol)}`,
      ); // Replace with your API
      const json = await response.json();
      setDetail(json);
      setShowPopup(true);
    } catch (error) {
      console.error('API call failed:', error);
    }
  };

  return (
    <div
      className="popup-container"
      style={{ margin: 0, padding: 0, cursor: 'pointer', display: 'inline' }}
    >
      <p
        onClick={handleClick}
        style={{
          margin: 0,
          padding: 0,
          cursor: 'target',
          display: 'inline',
          color: 'lightgreen',
        }}
      >
        {symbol}
      </p>

      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.popup} className='stockPopup'>
            <p>{symbol}</p>
            {detail && detail.profile && (
              <ProfileRow profile={detail.profile} ticker={symbol} symbolInfo={detail.symbolInfo} />
            )}

            {detail && (
              <div className="container">
                <div className="box">
                  <h5>90 day daily with 21-day sma</h5>
                  <CanvasItem
                    width={350}
                    height={250}
                    index={1}
                    ticker={symbol}
                    title={'90 day daily with 21-day sma'}
                    onPriceChange={(price) => {}}
                    chartData={detail.shortTermDailyChart}
                  />
                </div>
                <div className="box">
                  <h5>200 day daily with 50-day sma</h5>

                  <CanvasItem
                    width={350}
                    height={250}
                    index={1}
                    ticker={symbol}
                    title={'200 day daily with 50-day sma'}
                    onPriceChange={(price) => {}}
                    chartData={detail.longTermDailyChart}
                  />
                </div>
                <div className="box">
                  <h5>15 day 30min chart with 5-day sma</h5>

                  <CanvasItem
                    width={350}
                    onPriceChange={(price) => {}}
                    height={250}
                    index={1}
                    ticker={symbol}
                    title={'15 day 30min chart with 5-day sma'}
                    chartData={detail.intradayChart}
                  />
                </div>
              </div>
            )}

            <button
              onClick={() => {
                setShowPopup(false);
                setDetail(null);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    zIndex: 999,
  },
  popup: {
    backgroundColor: 'black',
    padding: '20px',
    borderRadius: '8px',
    minWidth: '200px',
    maxWidth: '60%',
    boxShadow: '0 0 10px rgba(0,0,0,0.25)',
  },
  button: {
    backgroundColor: 'black',
    color: 'yellow',
  },
  p: {
    margin: 0,
    padding: 0,
    cursor: 'target',
  },
  popupContainer: {
    margin: 0,
    padding: 0,
    cursor: 'target',
  },
  profile: {
    backgroundColor: 'black'
  }
};

export default StockPopupButton;
